import { CIcon } from '~/icons/types'

export const ciShieldCheck: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'm20.176 4.532-8-3a.5.5 0 0 0-.352 0l-8 3A.5.5 0 0 0 3.5 5v7c0 6.237 7.938 10.278 8.276 10.447a.5.5 0 0 0 .448 0c.338-.169 8.276-4.21 8.276-10.447V5a.5.5 0 0 0-.324-.468ZM19.5 12c0 5.071-6.231 8.739-7.5 9.434-1.271-.694-7.5-4.356-7.5-9.434V5.347L12 2.534l7.5 2.813V12Z'
    },
    {
      d:
        'M9.354 11.647a.501.501 0 0 0-.708.708l2 2a.5.5 0 0 0 .708 0l4-4a.499.499 0 0 0-.162-.817.5.5 0 0 0-.546.109L11 13.294l-1.646-1.647Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'shield-check',
  type: 'light'
}
